import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface I_IdentificationFormMeta {
    dbaName: FormInputMeta;
    creationDate: FormInputMeta;
    agency: FormInputMeta;
    trader: FormInputMeta;

    schema: any;
}

const identificationFormMeta = {} as I_IdentificationFormMeta;

identificationFormMeta.dbaName = {
    name: "dbaName",
    type: "text",
    label: "D/B/A Name",
    placeholder: "D/B/A Name",
    validation: yup.string().required("Champ obligatoire !")
};

identificationFormMeta.creationDate = {
    name: "creationDate",
    type: "date",
    label: "Date Création",
    placeholder: "Date Création",
    validation: yup.date()
};

identificationFormMeta.agency = {
    name: "agency",
    type: "select",
    label: "Agence",
    placeholder: "Agence",
    validation: yup.string().required("Champ obligatoire !")
};

identificationFormMeta.trader = {
    name: "trader",
    type: "select",
    label: "Commerçant",
    placeholder: "Commerçant",
    validation: yup.string().required("Champ obligatoire !")
};


identificationFormMeta.schema = yup.object().shape(getValidationSchema(identificationFormMeta));

export default identificationFormMeta;